import { Injectable } from '@angular/core';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more.src';
import SolidGauge from 'highcharts/modules/solid-gauge';

HighchartsMore(Highcharts);
SolidGauge(Highcharts);


@Injectable({
  providedIn: 'root'
})
export class GenerateGaugeServiceService {

  constructor() { }

  public getChart(value: number): Chart {
    return this.generateChart(value);
  }

  private generateChart(value: number): Chart {
    return new Chart({
      chart: {
        type: 'solidgauge',
        styledMode: false,
        reflow: true,
        spacingTop: 0,
        spacingLeft: 0,
        spacingRight: 0,
        spacingBottom: 0,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        height: (8 / 16 * 88) + '%',
        width: null,
        animation: false,
        plotBackgroundImage: null,
        events: {
          load() {
            // Identifiers are never reassigned better to use const in this case
            const chart = this;
            chart.reflow();
          }
        }
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      pane: {
        center: ['50%', '100%'],
        size: '200%',
        startAngle: -90,
        endAngle: 90,
        // Pane Background is the Half Donut Arc
        background: [{
          borderWidth: 1,
          innerRadius: '60%',
          outerRadius: '100%',
          shape: 'arc'
        }]
      },
      tooltip: {
        enabled: false
      },
      yAxis: {
        min: 0,
        max: 100,
        stops: value > 0 ? [
          [0.0, '#f1c550'], // yellow
          [0.4, '#71a95a'], // light green
          [0.8, '#007944'], // dark green
        ] :
          [
            [0.0, '#f1c550'], // yellow
            [0.4, '#ff6600'], // orange
            [0.8, '#ce2525'], // red
          ],
        // Plotbands are the tiny gray upper line in Gauge
        plotBands: Math.abs(value) > 100 ? (
          value > 0 ? [{
            from: 0,
            to: (value - 100),
            color: 'rgba(1, 84, 47, 1)',
            zIndex: 100
          }] :
            [{
              from: 0,
              to: (Math.abs(value) - 100),
              color: 'rgba(143, 0, 0, 1)',
              zIndex: 100
            }]) :
          [{
            from: 0,
            to: 100,
            color: 'rgba(0,0,0,0.05)',
          }]
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            y: 50,
            borderWidth: 0,
            useHTML: true,
            format: value + '&'
          }
        }
      },
      series: [
        {
          type: 'solidgauge',
          name: 'Percentage',
          data: [Math.abs(value)] as Highcharts.SeriesGaugeDataOptions,
          dataLabels: {
            format:
              '<div ' + (value < 0 ? 'id="rotate180-text"' : '') + ' style="text-align:center">' +
              '<span style="font-size:25px">' + value.toFixed(2) + '</span><br/>' +
              '<span style="font-size:12px;opacity:0.4">procent</span>' +
              '</div>'
          }
        } as Highcharts.SeriesOptionsType
      ]
    });
  }

}
